<template>
    <div>
        <div class="mb-10 d-flex flex-row gap-10">
            <div class="flex-grow-1">
                <div class="font-size-lg font-weight-bold">
                    <i class="fas fa-user-lock mr-2"/>
                    {{ __('actions.add_thing', {thing: __('user.mfa')}) }}
                </div>
                <div v-if="!mfaSessionStarted" class="text-muted mt-1">
                    {{ __('user.enable_mfa_re_authenticate') }}
                </div>
            </div>
            <div>
                <button class="btn btn-light-danger" @click="close">
                    <i class="fas fa-times-circle mr-n1"/>
                </button>
            </div>
        </div>

        <div v-if="!localUser" class="d-flex flex-row justify-content-center">
            <Authentication class="w-md-75" @authenticated="userAuthenticated"/>
        </div>
        <div v-else class="d-flex flex-row justify-content-center">
            <div class="w-md-75 d-flex flex-column gap-4">
                <!-- ERRORS -->
                <ErrorBox v-if="error !== null" :error="error"/>

                <!-- FORM -->
                <FormGroupNew :label="__('user.mobile_number')"
                              :description="__('actions.provide_thing', {thing: __('user.mobile_number')})"
                              no-margin
                              required
                >
                    <input class="form-control"
                           :class="{'form-control-solid': mfaCodeRequested}"
                           type="text"
                           :disabled="mfaCodeRequested"
                           v-model="mobile"
                    >
                </FormGroupNew>
                <div v-show="!mfaCodeRequested"
                     ref="reCaptcha"
                />
                <FormGroupNew v-if="mfaCodeRequested"
                              :label="__('user.mfa_code')"
                              :description="__('actions.provide_thing', {thing: __('user.mfa_code')})"
                              no-margin
                              required
                >
                    <input class="form-control"
                           type="text"
                           v-model="mfaCode"
                    >
                </FormGroupNew>

                <!-- BUTTONS -->
                <button v-if="!mfaCodeRequested"
                        class="btn btn-primary"
                        :disabled="mobile.length === 0"
                        @click="requestMfaCode"
                >
                    <i class="fas fa-paper-plane"/>
                    {{ __('actions.send_thing', {thing: __('auth.mfa_code')}) }}
                </button>
                <button v-if="mfaCodeRequested"
                        class="btn btn-primary"
                        @click="verifyMfaCode"
                >
                    <i class="fas fa-check-circle"/>
                    {{ __('actions.sign_in') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import Authentication from "@components/Auth/Authentication.vue";
import authMixin from "@mixins/authMixin";
import {multiFactor, PhoneAuthProvider, PhoneMultiFactorGenerator, RecaptchaVerifier} from "firebase/auth";
import ErrorBox from "@components/Auth/ErrorBox.vue";

export default {
    components: {ErrorBox, Authentication, FormGroupNew},

    mixins: [authMixin],

    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mfaCodeRequested: false,
            verificationId: null,
            mfaSession: null,
            mfaSessionStarted: false,
            recaptchaVerifier: null,
            error: null,
            mobile: '',
            mfaCode: ''
        }
    },

    methods: {
        displayError(error) {
            this.error = this.mapAuthError(error);
        },

        userAuthenticated(user) {
            this.localUser = user;

            multiFactor(user)
                .getSession()
                .then((multiFactorSession) => {
                    this.mfaSessionStarted = true;
                    this.mfaSession = multiFactorSession;
                    this.recaptchaVerifier = new RecaptchaVerifier(this.authenticator, this.$refs.reCaptcha);
                })
                .catch(this.displayError);
        },

        requestMfaCode() {
            this.error = null;

            new PhoneAuthProvider(this.authenticator).verifyPhoneNumber({
                phoneNumber: this.mobile,
                session: this.mfaSession
            }, this.recaptchaVerifier)
                .then((verificationId) => {
                    this.verificationId = verificationId;
                    this.mfaCodeRequested = true;
                })
                .catch(error => {
                    this.mfaCodeRequested = false;
                    this.error = this.mapAuthError(error);
                });
        },

        verifyMfaCode() {
            if (!this.verificationId) {
                console.error('Can not verify MFA code if verification ID is not yet set.')
                return;
            }

            const cred = PhoneAuthProvider.credential(this.verificationId, this.mfaCode);
            const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);

            multiFactor(this.localUser)
                .enroll(multiFactorAssertion)
                .then(() => {
                    toastr.success(__('general.thing.enabled', {thing: __('user.mfa')}))
                    this.$emit('enabled')
                })
                .catch(this.displayError);
        },

        close() {
            this.$emit('close');
        }
    }
}
</script>
